export var FT_PI_ENABLE_PAYPAL = 'kill_switch_pi_enable-paypal';
export var FT_BB_ENABLE_PAYPAL = 'kill_switch_bb_enable-paypal';
export var FT_PI_ENABLE_PAYMENT_REDESIGN = 'release_pi_payment_redesign';
export var FT_BB_ENABLE_PAYMENT_REDESIGN = 'release_bb_payment_redesign';
export var FT_PI_AMEND_GUEST_ADDRESS = 'release_pi_amend_guest_address';
export var FT_CCUI_AMEND_GUEST_ADDRESS = 'release_ccui_amend_guest_address';
export var FT_CCUI_PRE_CHECK_IN_LABEL = 'release_ccui_pre_check_in_label';
export var FT_PI_PRE_CHECK_IN = 'release_pi_pre_check_in';
export var FT_PI_GDP_BILLING_ADDRESS = 'release_pi_gdp_billing_address';
export var FT_CCUI_GDP_BILLING_ADDRESS = 'release_ccui_indigo_gdp-billing-address';
export var FT_CCUI_GDP_MULTI_BOOKING = 'release_ccui_indigo_gdp-multi-booking';
export var FT_CCUI_GDP_SINGLE_BOOKING = 'release_ccui_indigo_gdp-single-booking';
export var FT_PI_GDP_PAGE_DESIGN_CHANGE = 'release_pi_gdp_page_design_change';
export var FT_PI_ADDITIONAL_INFORMATION = 'release_pi_additional_information';
export var FT_PI_AMEND_DELETE_REG_CARD = 'release_pi_amend_delete_reg_card';
export var FT_CCUI_ADDITIONAL_INFORMATION = 'release_ccui_additional_information';
export var FT_IB_OUT_OF_POLICY_REPORT = 'release_ib_out_of_policy_report';
export var FT_IB_BOOKING_ALERTS = 'release_ib_booking_alerts';
export var FT_IB_PAY_PIBA_EURO = 'release_ib_pay_piba_euro';
export var FT_IB_STATEMENTS_INVOICES = 'release_ib_statements_invoices';
export var FT_IB_TRANSACTIONS = 'release_ib_transactions';
export var FT_IB_WL_CARD_EDIT = 'release_ib_wl_card_edit';
export var FT_IB_DD_STATUS_POLLING = 'release_ib_dd_status_polling';
export var FT_IB_COST_CENTRE_MANAGEMENT = 'release_ib_cost_centre_management';
export var FT_PI_RECAPTCHA_REGISTER = 'kill_switch_pi_recaptcha_register_page';
export var FT_CCUI_PRE_POPULATE_BILLING_ADDRESS = 'release-pre-populate-different-billing-address-ccui';
export var FT_PI_BB_CCUI_TRIP_ADVISOR = 'release_pi_bb_ccui_white_trip_advisor_review';
export var FT_PI_GROUP_BOOKING_FORM = 'release_pi_group_booking_form';
export var FT_BB_GROUP_BOOKING_FORM = 'release_bb_group_booking_form';
export var FT_PI_HREFLANG_ATTRIBUTE = 'release_pi_hreflang_attribute';
export var FT_PI_WEB_PUSH_NOTIFICATIONS = 'release_pi_web_push_notifications';
export var FT_PI_BREAKFAST_PROMO_CODE = 'release_pi_breakfast_promo_code';
export var FT_PI_FREE_FNB_AND_EXTRAS = 'release_pi_free_fnb_and_extras';
export var FT_BB_FREE_FNB_AND_EXTRAS = 'release_bb_free_fnb_and_extras';
export var FT_CCUI_FREE_FNB_AND_EXTRAS = 'release_ccui_free_fnb_and_extras';
export var FT_PI_GROUP_WEB_SSR_REST_CALL = 'release_pi_group_booking_form_ssr_rest_call';
export var FT_CCUI_CHANGE_PAYMENT_METHOD = 'release_ccui_change_payment_method';
export var FT_PI_META_CLASS_RATE_SEARCH = 'kill_switch_pi_meta_search';
export var FT_PI_CP_CREATE_ACCOUNT = 'release_pi_cp_create_account';
export var FT_CCUI_ACCOMPANYING_GUEST_DETAILS = 'release_ccui_accompanying_guest_details';
export var FT_PI_BB_ACCOUNT_SERV_TO_SERV = 'release_pi_bb_account_serv_2_serv';
export var FT_PI_DISCOUNT_RATE = 'release_pi_discount_rate';
export var FT_BB_ACCOMPANYING_GUEST_DETAILS = 'release_bb_accompanying_guest_details';
export var FT_PI_BB_CCUI_COMPANY_NAME_SPECIAL_CHARACTERS = 'release_pi_bb_ccui_company_name_special_characters';
export var FT_PI_ACCOMPANYING_GUEST_DETAILS = 'release_pi_accompanying_guest_details';
export var FT_CCUI_SEARCH_NEGOTIATED_RATES_BY_CORP_ID = 'release_ccui_search_negotiated_rates_by_corpId';
export var FT_PI_AEM_PAGE_CSR_ONLY = 'release_pi_aem_page_csr_only';
export var FT_PI_AEM_PAGE_NO_SANITIZE = 'release_pi_aem_page_no_sanitize';
export var FT_PI_BB_CCUI_NONSILENT_SUBSTITUTION_PER_ROOMCLASS = 'release_pi_bb_ccui_nonsilent_substitution_per_roomclass';
export var FT_PI_BB_CCUI_MAXROOMS_AMEND = 'release_pi_bb_ccui_maxrooms_amend';
export var FT_PI_BB_CCUI_DISABLE_PAYMENTS = 'kill_switch_pi_bb_ccui_disable_payments';
export var FT_CCUI_ENABLE_72H_UK_NOTIFICATION = 'kill_switch_ccui_uk_enable_payments_within_72h';
export var FT_CCUI_ENABLE_72H_DE_NOTIFICATION = 'kill_switch_ccui_de_enable_payments_within_72h';
export var FT_PI_CCUI_BB_PREM_PLUS_ACCESSIBLE = 'release_pi_bb_ccui_premier_plus_accessible_room';
export var FT_PI_PROMO_CODE_LANDING_PAGE = 'release_pi_promo_code_landing_page';
export var FT_PI_PROMO_CODE_SITE_WIDE = 'release_pi_promo_code_site_wide';
export var FT_CCUI_PROMO_CODE_LANDING_PAGE = 'release_ccui_promo_code_landing_page';
export var FT_CCUI_PROMO_CODE_SITE_WIDE = 'release_ccui_promo_code_site_wide';
export var FT_BB_PROMO_CODE_LANDING_PAGE = 'release_bb_promo_code_landing_page';
export var FT_BB_PROMO_CODE_SITE_WIDE = 'release_bb_promo_code_site_wide';
export var FT_PI_BB_CCUI_ROOMS_DISCLAIMER = 'release_pi_bb_ccui_rooms_disclaimer';
export var FT_PI_SORT_ORDER_DROPDOWN = 'release_pi_sort_order_dropdown';
export var FT_BB_SORT_ORDER_DROPDOWN = 'release_bb_sort_order_dropdown';
export var FT_PI_BB_CCUI_CHOOSE_ROOM_TYPE = 'release_pi_bb_ccui_choose_room_type';
export var FT_PI_BB_CCUI_BARRIER_FREE_LABEL = 'release_pi_bb_ccui_barrier_free_label';
export var FT_PI_PRICE_PER_NIGHT = 'release_pi_price_per_night';
export var FT_BB_PRICE_PER_NIGHT = 'release_bb_price_per_night';
export var FT_CCUI_PRICE_PER_NIGHT = 'release_ccui_price_per_night';
export var FT_PI_BB_NON_GUARANTEED_REMINDER = 'release_pi_bb_non_guaranteed_reminder';
export var FT_PI_ROOM_UPGRADE_POPUP = 'release_pi_room_upgrade_popup';
export var FT_BB_ROOM_UPGRADE_POPUP = 'release_bb_room_upgrade_popup';
export var FT_PI_KILL_SWITCH_CHAT_BOX = 'kill_switch_hide_chat_bot_pi';
export var FT_PI_SHOW_CHAT_BOT_ALL_PAGES = 'release_show_chat_bot_all_pages_pi';
export var FT_PI_SUMMER_SALE_PROMO_BANNER = 'release_pi_summer_sale_promotion_banner';
export var FT_PI_BB_CANCELLATION_POLICY = 'release_pi_bb_cancellation_policy';
export var FT_IB_USER_PILOT = 'release_ib_user_pilot';
export var FT_PI_NEW_DLP_FILTERS = 'release_pi_new_dlp_filters';
export var FT_PI_SIGNUP_IN_HEADER = 'release_pi_signup_in_header';
export var FT_PI_BB_CCUI_COUNTRY_SELECTOR_FILTERABLE = 'release_pi_bb_ccui_country_selector_filterable';
export var FT_PI_BB_CCUI_SHOW_MEALS_FREE = 'release_pi_bb_ccui_show_meals_package';
export var FT_PI_CCUI_CONSOLIDATE_MOBILE_LANDLINE = 'release_pi_ccui_consolidate_mobile_landline';
export var FT_PI_BOOKING_STEPS_WITH_TITLE = 'release_pi_ccui_booking_steps_with_title';
export var FT_PI_BB_CCUI_HDP_IMAGE_GALLERY_REDESIGN = 'release_pi_bb_ccui_hdp_image_gallery_redesign';
export var FT_PI_BB_CCUI_SRP_MULTIPLE_IMAGES = 'release_pi_bb_ccui_srp_multiple_images';
export var FT_PI_PRICE_FINDER_SEO_NOINDEX = 'release_pi_price_finder_seo_noindex';
export var FT_BB_MARKETING_EMAIL_OPTIN = 'release_bb_marketing_email_optin';
export var FT_PI_BB_BOOKING_HISTORY_REDESIGN = 'release_pi_bb_booking_history_redesign';
export var FT_PI_SHOW_PROMOTION_BOX = 'release_pi_show_promotion_box';
export var FT_BB_SHOW_PROMOTION_BOX = 'release_bb_show_promotion_box';
export var FT_CCUI_SHOW_PROMOTION_BOX = 'release_ccui_show_promotion_box';
export var FT_PI_CCUI_BB_PROMOTION_BOX_CODE_COOKIE = 'release_pi_ccui_bb_promotion_box_code_cookie';
export var FT_CCUI_UNIQUE_PROMO_CODE = 'release_ccui_unique_promo_code';
export var FT_PI_BASKET_IDS_COOKIE_VALIDATION = 'release_basket_ids_cookie_validation';
export var FT_CCUI_BOOKING_HISTORY_REDESIGN = 'release_ccui_booking_history_redesign';
export var FT_PIB_BUSINESS_PAY_USER = 'release_pib_business_pay_user';
export var FT_PI_NO_ROOM_TYPE_SEARCH = 'release_pi_no_room_type_search';
export var FT_IB_REDIRECT_AFTER_LOGIN = 'release_ib_redirect_after_login';
export var FT_PI_PIB_CCUI_SHOW_LOWEST_PRICE_MONTH_TAB = 'release_pi_pib_ccui_lowest_price_in_month_tab';
export var FT_PI_PIB_CCUI_SHOW_FILTER_ROOM_TYPES = 'release_pi_pib_ccui_filter_room_type';
export var FT_PI_TWO_MONTH_SEARCH = 'release_pi_two_month_search';
export var FT_PI_BOOKING_STATUS_IN_BIC_HEADER = 'release_pi_booking_status_in_bic_header';
export var FT_PI_DISPLAY_SOFT_BUNDLES = 'release_pi_display_soft_bundles';
export var FT_IB_CONTACT_US_CARD_LIVE_CHAT = 'release_ib_contact_us_card_live_chat';
export var FT_PI_PIB_SWAP_PAYMENT_OPTIONS = 'release_pi_pib_swap_payment_options';
export var FT_IB_YOUR_SPENDING = 'release_ib_your_spending';
export var FT_PI_PIB_CCUI_CITY_TAX_BREAKDOWN = 'release_pi_pib_ccui_city_tax_breakdown';
export var FT_PI_PIB_CCUI_CITY_TAX_BREAKDOWN_ANCILLARIES_GDP_PAYMENT = 'release_pi_pib_ccui_city_tax_breakdown_ancillaries_gdp_payment';
export var FT_PI_PIB_CCUI_CITY_TAX_AMEND = 'release_pi_pib_ccui_city_tax_amend';
export var FT_PI_PIB_PAYMENT_BACK_TO_OPTIONS_LINK = 'release_pi_pib_payment_back_to_options_link';
export var FT_PI_ADD_TO_WALLET = 'release_pi_add_to_wallet';
export var FT_PI_AUTH0_LOGIN = 'release_pi_auth0_login';
export var FT_PI_PIB_CCUI_ENABLE_HUB_HOTELS_POA = 'release_pi_pib_ccui_enable_hub_hotels_poa';
export var FT_PI_PIB_BIC_DOWNLOAD_INVOICE = 'release_pi_pib_bic_download_invoice';
export var FT_PI_BB_CONTROLS_MOBILE_DISPLAY = 'release_pi_bb_mobile_controls_display';
export var FT_IB_PIBA_MEMORABLE_WORD_IFRAME = 'release_piba_cnp_iframe_split';
export var FT_PIB_LOGIN_REDIRECT = 'release_pib_login_redirect';
export var FT_PI_BB_SHOW_GOOGLE_STATIC_MAP = 'release_pi_bb_show_google_static_map';
export var FT_PI_ANALYTICS_DEBOUNCE = 'release_pi_analytics_debounce';
export var FT_PI_ROOM_DETAILS_DRAWER = 'release_pi_room_details_drawer';
export var FT_PI_HDP_URGENCY_BANNER = 'kill_switch_enable_urgency_banner';
export var FT_PI_REMOVE_PII_DATA_FROM_LOCAL_STORAGE = 'release_pi_remove_pii_data_from_local_storage';
export var FT_CCUI_REMOVE_PII_DATA_FROM_LOCAL_STORAGE = 'release_ccui_remove_pii_data_from_local_storage';
export var FT_SRP_DYNAMIC_FILTERS = 'release_srp_dynamic_filters';
export var FT_SEMANTIC_TYPOGRAPHY_TOKENIZATION = 'release_semantic_typography_tokenization';
export var FT_PI_BB_CCUI_PROMOTIONS_IN_HOTELAVAILABILITY = 'release_promotions_in_hotelavailability';
export var FT_PI_SRP_SPLIT_MAP_VIEW = 'release_pi_srp_split_map_view';
export var FT_ONE_TRUST_COOKIE_CONSENT = 'release_one_trust_cookie_consent';
export var FT_DYNATRACE_RUM_COOKIE_CONSENT = 'release_dynatrace_rum_cookie_consent';
export var FT_PI_DATATRANS_INTEGRATION = 'release_datatrans_integration';
export var FT_PI_REDIS_RQ_CACHE = 'release_pi_redis_rq_cache';
export var FT_MOBILE_PREREGISTERED_REPURPOSE = 'mobile_preRegistered_repurpose';